var map = {
	"./default-person.png": "./app/javascript/images/default-person.png",
	"./delete.png": "./app/javascript/images/delete.png",
	"./drawlogo_en.png": "./app/javascript/images/drawlogo_en.png",
	"./drawlogo_fr.png": "./app/javascript/images/drawlogo_fr.png",
	"./feather_icon.png": "./app/javascript/images/feather_icon.png",
	"./holiday-bg.jpg": "./app/javascript/images/holiday-bg.jpg",
	"./mcgill-background.jpg": "./app/javascript/images/mcgill-background.jpg",
	"./okButton.png": "./app/javascript/images/okButton.png",
	"./partners/Geothink_Logo_NT.png": "./app/javascript/images/partners/Geothink_Logo_NT.png",
	"./partners/Geothink_Logo_T2.jpg": "./app/javascript/images/partners/Geothink_Logo_T2.jpg",
	"./partners/McGill_logoT.gif": "./app/javascript/images/partners/McGill_logoT.gif",
	"./partners/cirm.jpg": "./app/javascript/images/partners/cirm.jpg",
	"./partners/criem.png": "./app/javascript/images/partners/criem.png",
	"./pencil.png": "./app/javascript/images/pencil.png",
	"./shadow.png": "./app/javascript/images/shadow.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";